import { useEffect } from 'react';

const DASHBOARD_HEADER_TOUR_STORAGE_KEY = 'dashboard-header-tour-seen';

interface UseDashboardHeaderTourAutoStartParams {
  isDashboardLoaded: boolean;
  isMobileDashboardView: boolean;
  onStartHeaderTour: () => void;
}

const hasSeenDashboardHeaderTour = (): boolean => {
  try {
    return window.localStorage.getItem(DASHBOARD_HEADER_TOUR_STORAGE_KEY) === 'true';
  } catch {
    return true;
  }
};

const markDashboardHeaderTourSeen = (): void => {
  try {
    window.localStorage.setItem(DASHBOARD_HEADER_TOUR_STORAGE_KEY, 'true');
  } catch {
    // Ignore storage failures; tour can still run for this session.
  }
};

export const useDashboardHeaderTourAutoStart = ({
  isDashboardLoaded,
  isMobileDashboardView,
  onStartHeaderTour,
}: UseDashboardHeaderTourAutoStartParams): void => {
  useEffect(() => {
    if (!isDashboardLoaded || isMobileDashboardView || hasSeenDashboardHeaderTour()) {
      return;
    }

    markDashboardHeaderTourSeen();
    onStartHeaderTour();
  }, [isDashboardLoaded, isMobileDashboardView, onStartHeaderTour]);
};
